export default [
    {
      path: '/mobile/v2/users',
      meta: { layout: "default", renderNavBar: true, renderSideBar: true },
      name: 'MobileV2Users',
      component: () => import('@/pages/pagesMobileV2/Users/index.vue')
    },
    {
      path: '/mobile/v2/users/filter',
      meta: { layout: "default", renderNavBar: true, renderSideBar: true },
      name: 'MobileV2FilteredUsers',
      component: () => import('@/pages/pagesMobileV2/Users/filteredUsers.vue')
    },
    {
      path: '/mobile/v2/taskStatus',
      meta: { layout: "default", renderNavBar: true, renderSideBar: true },
      name: 'MobileV2TaskStatus',
      component: () => import('@/pages/pagesMobileV2/TaskStatus/index.vue')
    },
    {
      path: '/mobile/v2/task/:id/data',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2TaskData',
      component: () => import('@/pages/pagesMobileV2/TaskData/index.vue')
    },
    {
      path: '/mobile/v2/task/notify',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2TaskNotify',
      component: () => import('@/pages/pagesMobileV2/NotifyTask/index.vue')
    },
    {
      path: '/mobile/v2/receipt',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2Receipts',
      component: () => import('@/pages/pagesMobileV2/Receipts/index.vue')
    },
    {
      path: '/mobile/v2/receipt/addData/:receiptId/:userId',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2ReceiptAddData',
      component: () => import('@/pages/pagesMobileV2/Receipts/addData.vue')
    },
    {
      path: '/mobile/v2/tasks',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2Tasks',
      component: () => import('@/pages/pagesMobileV2/Tasks/index.vue')
    },
    {
      path: '/mobile/v2/tasks/create',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2TasksCreate',
      component: () => import('@/pages/pagesMobileV2/Tasks/create.vue')
    },
    {
      path: '/mobile/v2/cashout',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2Cashout',
      component: () => import('@/pages/pagesMobileV2/Cashout/index.vue')
    },
    {
      path: '/mobile/v2/cashout/ewallet',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2CashoutEWallet',
      component: () => import('@/pages/pagesMobileV2/Cashout/ewallet.vue')
    },
    {
      path: '/mobile/v2/deals',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2Deals',
      component: () => import('@/pages/pagesMobileV2/Deals/index.vue')
    },
    {
      path: '/mobile/v2/userProfile/:userId',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2UserProfile',
      component: () => import('@/pages/pagesMobileV2/UserProfile/index.vue')
    },
    {
      path: '/mobile/v2/assignTask',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2AssignTask',
      component: () => import('@/pages/pagesMobileV2/AssignTask/index.vue')
    },
    {
      path: '/mobile/v2/iconsume',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2IConsume',
      component: () => import('@/pages/pagesMobileV2/IConsume/index.vue')
    },
    {
      path: '/mobile/v2/issues',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2Issues',
      component: () => import('@/pages/pagesMobileV2/Issues/index.vue')
    },
    {
      path: '/mobile/v2/issues/:issueId',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2Issue',
      component: () => import('@/pages/pagesMobileV2/Issues/issue.vue')
    },
    {
      path: '/mobile/v2/project/data',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2ProjectData',
      component: () => import('@/pages/pagesMobileV2/ProjectData/index.vue')
    },
    {
      path: '/mobile/v2/project/data/submission/:submissionId',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2ProjectSubmission',
      component: () => import('@/pages/pagesMobileV2/ProjectData/data.vue')
    },
    {
      path: '/mobile/v2/project/data/edit/:userId',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2ProjectSubmissionEdit',
      component: () => import('@/pages/pagesMobileV2/ProjectData/edit.vue')
    },
    {
      path: '/mobile/v2/project/data/grouped',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2GroupedSubmission',
      component: () => import('@/pages/pagesMobileV2/ProjectData/grouped.vue')
    },
    {
      path: '/mobile/v2/rewards',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2Rewards',
      component: () => import('@/pages/pagesMobileV2/Rewards/index.vue')
    },
    {
      path: '/mobile/v2/rewards/add',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2AddReward',
      component: () => import('@/pages/pagesMobileV2/Rewards/addReward.vue')
    },
    {
      path: '/mobile/v2/iconsume/add/:userId/:submissionId',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2AddIConsume',
      component: () => import('@/pages/pagesMobileV2/IConsume/addData.vue')
    },
    {
      path: '/mobile/v2/profiling/question/view',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2ProfilingQuestion',
      component: () => import('@/pages/pagesMobileV2/ProfilingQuestion/index.vue')
    },
    {
      path: '/mobile/v2/profiling/question/add',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2AddProfilingQuestions',
      component: () => import('@/pages/pagesMobileV2/ProfilingQuestion/add.vue')
    },
    {
      path: '/mobile/v2/profiling/:id',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2ProfilingEdit',
      component: () => import('@/pages/pagesMobileV2/ProfilingQuestion/edit.vue')
    },
    {
      path: '/mobile/v2/analytics/profiling',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2ProfilingAnalytics',
      component: () => import('@/pages/pagesMobileV2/ProfilingQuestion/analytics.vue')
    },
    {
      path: '/mobile/v2/profiling/responses/:surveyId',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2ProfilingResponses',
      component: () => import('@/pages/pagesMobileV2/ProfilingQuestion/responses.vue')
    },
    {
      path: '/mobile/v2/pushNotification',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2PushNotification',
      component: () => import('@/pages/pagesMobileV2/PushNotification/index.vue')
    },
    {
      path: '/mobile/v2/outernet',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2Outernet',
      component: () => import('@/pages/pagesMobileV2/Outernet/index.vue')
    },
    {
      path: '/mobile/v2/outernet/submission/:submissionId',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2OuternetSubmission',
      component: () => import('@/pages/pagesMobileV2/Outernet/submission.vue')
    },
    {
      path: '/mobile/v2/outernet/dashboard',
      meta: {
        layout: "default", guest: true
      },
      name: 'MobileV2OuternetDashboard',
      component: () => import('@/pages/pagesMobileV2/Outernet/dashboard.vue')
    },
    {
      path: '/mobile/v2/outernet/qualityCheck',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2OuternetQualityCheck',
      component: () => import('@/pages/pagesMobileV2/Outernet/qualityCheck.vue')
    },
        {
      path: '/mobile/v2/outernet/heatmap',
      meta: {
        layout: "default",
        outernetHeatmapViewer: true,
      },
      name: 'MobileV2OuternetHeatmap',
      component: () => import('@/pages/pagesMobileV2/Outernet/heatmap.vue')
    },
    {
      path: '/mobile/v2/outernet/inventory-map',
      meta: {
        layout: "default",
        outernetHeatmapViewer: true,
      },
      name: 'MobileV2OuternetInventoryScanMap',
      component: () => import('@/pages/pagesMobileV2/Outernet/inventoryScanMap.vue')
    },
    {
      path: '/mobile/v2/outernet/coverage-map',
      meta: {
        layout: "default",
        outernetHeatmapViewer: true,
      },
      name: 'MobileV2OuternetCoverageMap',
      component: () => import('@/pages/pagesMobileV2/Outernet/coverageComparisonMap.vue')
    },
    {
      path: '/mobile/v2/audios',
      meta: {
        layout: "default", renderNavBar: true, renderSideBar: true
      },
      name: 'MobileV2Audios',
      component: () => import('@/pages/pagesMobileV2/Audios/index.vue')
    },
]